import { loadSeonFingerprintSdk } from './loaders'

export const initSeon = async () => {
  try {
    const { default: seon } = await loadSeonFingerprintSdk()

    seon.init()
  } catch {
    return null
  }
}

export const getSeonSession = async () => {
  try {
    const { default: seon } = await loadSeonFingerprintSdk()

    return await seon.getSession({
      dnsResolverDomain: 'seondfresolver.com',
      region: 'eu',
      silentMode: true,
    })
  } catch {
    return null
  }
}
